import React from 'react';

const InputField = ({
    value,
    label = '',
    name,
    placeholder,
    min_length = "",
    maxLength = "",
    textType = "text",
    className = "form-control",
    onChange,
    disabled = false,
    required = false,
    ...props
}) => {

    return (
        <>
            {
                label && <label htmlFor="name" className="mb-0">
                    <strong>{label}</strong>
                    {required === true && <span style={{ color: 'red' }} > * </span>}
                </label>
            }
            {
                textType === "textarea" ?
                    <textarea
                        value={value}
                        name={name}
                        minLength={min_length}
                        maxLength={maxLength}
                        className={`${className}`}
                        placeholder={placeholder}
                        rows="5"
                        cols="40"
                        onChange={onChange}
                        disabled={disabled}
                        style={{ border: "1px solid", borderRadius: "5px" }}
                        {...props}
                    />
                    :
                    <input
                        label={label}
                        key={name?.toString()}
                        value={value}
                        name={name}
                        type={textType}
                        className={`${className} form-control`}
                        placeholder={placeholder}
                        onChange={onChange}
                        disabled={disabled}
                        size='small'
                        style={{ height: '50px', border: "1px solid", borderRadius: "5px" }}
                        {...props}
                    />
            }
        </>
    );
};

export default InputField;